var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"id":"coi-action-bar-reprint-label","block":""},on:{"click":function($event){return _vm.submit()}}},[_vm._v("\n    Erneut drucken\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }